export const READING_VALIDATION_MESSAGES = {
  DUPLICATE: 'A reading with this date already exists',
  FUTURE_DATE: 'Only estimated reading can have a reading date in the future',
  TOO_LOW:
    'Reading is too low. We expect the reading to be higher than the previous reading of',
  TOO_HIGH:
    'Reading is too high. We expect the reading to be lower than the next reading of'
}
